'use client'

import Section, { SectionProps } from '@lyra/core/components/Section'
import React from 'react'

import SignInButton from '../common/SignInButton'

type Props = { label?: string } & SectionProps

export default function HomeConnectPromptSection({
  label = 'Connect a wallet to get started.',
  ...sectionProps
}: Props) {
  return (
    <Section {...sectionProps}>
      <Section.Header title="Get Started" subtitle={label} />
      <Section.XStack>
        <SignInButton isCta size="lg" minWidth={140} />
      </Section.XStack>
    </Section>
  )
}
